import { render, staticRenderFns } from "./cModalActivos.vue?vue&type=template&id=25e8618f"
import script from "./cModalActivos.vue?vue&type=script&lang=js"
export * from "./cModalActivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports